module.exports = __webpack_public_path__ + "public/img/01.a6d23bf7.jpg";